import React from 'react';
import { useTimeMode } from '../context/TimeModeContext';

// Global CST-vs-local-time switch. Team defaults to CST since that's where
// operations/leadership are based, even though everyone sits in different
// countries — this lets anyone flip to seeing their own local time instead.
export default function TimeModeToggle() {
  const { mode, setMode } = useTimeMode();

  return (
    <div className="inline-flex rounded-lg border border-border bg-card p-0.5 text-[10px] font-semibold">
      <button
        onClick={() => setMode('cst')}
        className={`px-2 py-1 rounded-md transition-colors ${
          mode === 'cst' ? 'bg-gold text-white' : 'text-muted hover:text-ink'
        }`}
      >
        CST
      </button>
      <button
        onClick={() => setMode('local')}
        className={`px-2 py-1 rounded-md transition-colors ${
          mode === 'local' ? 'bg-gold text-white' : 'text-muted hover:text-ink'
        }`}
      >
        My time
      </button>
    </div>
  );
}
